import { validateOwnerData } from 'registration/actions/validate-owner-data.actions';
import { fetchOwnerValidationMethod } from 'registration/actions/fetch-owner-validation.actions';
import template from './independent.html';

const getOwnerValidationMethod = (validationMethod, locale) => {
  if (validationMethod[locale]) return validationMethod[locale][0];

  return validationMethod;
};

const mapStateToThis = ({ session, registration, config }) => {
  const { locale } = session;
  const { ownerData, ownerValidationMethod } = registration;
  const { phoneMask, phoneLength, maxFirstNameLength, maxLastNameLength, maxEmailLength, registrationLockoutPeriodMinutes } = config;

  return {
    ownerValidationMethod: getOwnerValidationMethod(ownerValidationMethod, locale),
    ownerData,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
    registrationLockoutPeriodMinutes,
  };
};

const mapDispatchToThis = {
  fetchOwnerValidationMethod,
  validateOwnerData,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Responsive')
class SelfRegistrationRetailerIndependentController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    await this.fetchOwnerValidationMethod();
    this.clearRegistrationForm();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async checkOwner(form) {
    const { passcode } = form;

    if (passcode.$pristine) return;

    this.isLoading = true;
    await this.validateOwnerData(this.formModel);
    this.isLoading = false;

    passcode.$setValidity('blocked', !this.ownerData.blocked);
    passcode.$setValidity('passcode', this.ownerData.validPin);
    passcode.$setValidity('isPinUsed', !this.ownerData.isPinUsed);
  }
}

export default class SelfRegistrationRetailerIndependentComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationRetailerIndependentController;
    this.bindings = {
      form: '=',
      formModel: '=',
      clearRegistrationForm: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/independent/independent-component.js